var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "tag",
      class: _vm.size,
      style: {
        "background-color": _vm.marker.color,
        color: _vm.checkColorIsBlackOrWhite(_vm.marker.color)
      }
    },
    [
      _c("span", {
        domProps: {
          innerHTML: _vm._s(_vm.customDescription || _vm.marker.description)
        }
      }),
      _vm._v(" "),
      _vm.isDeleted && _vm.marker.id
        ? _c("a", {
            staticClass: "delete is-small",
            attrs: { role: "button" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.$emit("delete", _vm.marker.id)
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fd2f531", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd2f531","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/components/sc-recon-marker/ScReconMarker.vue
// module id = null
// module chunks = 